import { render, staticRenderFns } from "./packageDetailBox.vue?vue&type=template&id=2a183669"
import script from "./packageDetailBox.vue?vue&type=script&lang=js"
export * from "./packageDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports